import printJS from "./print/";

let styleDefault = `
.text-center{
  text-align:center;
}
.text-left{
  text-align:left;
}
.text-right{
  text-align:right;
}
.print-box .info {
  margin-bottom: 20px;
}
.d-flex{
  display: flex !important;
}
.print-box{
  font-family: "Arial Unicode MS", Arial, Helvetica, sans-serif;
  font-size: 12px;
  margin:0px;
  padding:0px;
}
.print-box h3{
  font-size: 25px;
  margin:0px;
  margin-top: -10px;
}
.print-box .prtable {
  border-collapse: collapse;
  width: 100%;
  line-height: inherit;
  text-align: left;
}
.print-box .prtable.prtable-bordered {
  border: 1px solid #adaeaf;
}
.print-box .prtable.prtable-bordered th {
  border: 1px solid #909090;
  padding: 0px 10px;
  text-align: center;
  font-size: 14px;
}
.print-box .prtable.prtable-bordered td {
  text-align: center;
  font-size: 13px;
  padding: 0px 10px;
  border: 1px solid #adaeaf;
}
.print-box.tem {
  max-width:57mm;
  margin-top:5px;
  padding:0px;
}
.print-box.tem .prtable.prtable-bordered td {
  text-align: center;
  font-size: 11px;
  padding: 2px 1px;
  border: 1px solid #adaeaf;
}

.print-box.tem .prtable.prtable-bordered td.more{
  font-size:8.7px;
}

.print-box .footer {
  margin-top: 0px;
  padding: 0px;
}
.break-auto{
  page-break-inside: avoid;
}
.break-always{
  clear: both;
  page-break-after: always;
  page-break-inside: avoid;
}
.print-box .print-note ul, .print-box .print-note p {
  margin: 0px;
  font-size:12px;
}
`;

// function addStyles (win,styles) {
//   styles.forEach(style => {
//     let link = win.document.createElement("link");
//     link.setAttribute("rel", "stylesheet");
//     link.setAttribute("type", "text/css");
//     link.setAttribute("href", style);
//     win.document.getElementsByTagName("head")[0].appendChild(link);
//   });
// }

const Print = {
  install(Vue) {
    Vue.prototype.$print = content => {
      printJS({
        printable: content,
        type: "html",
        style: styleDefault
      });
    };
  }
};

export default Print;
